import { createAsyncThunk } from '@reduxjs/toolkit';
import { ServiceCategory } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchServiceCategory, FindServiceCategory } from './interface';

export const findServiceCategory = createAsyncThunk(
  'serviceCategory/find',
  async (values: FindServiceCategory, { rejectWithValue }) => {
    try {
      return await ServiceCategory.find({ query: values });
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createServiceCategory = createAsyncThunk(
  'serviceCategory/create',
  async (values: CreatePatchServiceCategory, { rejectWithValue }) => {
    try {
      return await ServiceCategory.create(values);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchServiceCategory = createAsyncThunk(
  'serviceCategory/patch',
  async ({ id, ...values }: CreatePatchServiceCategory, { rejectWithValue }) => {
    try {
      return await ServiceCategory.patch(id, values);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
